module.exports = new __parcel__URL__("Charlie_Display-Ultra.8ac32164.woff").toString();